module.exports = __webpack_public_path__ + "static/media/the-game-aflw-2026-v2.40cd3ba9.webp";